import behaviourParams_gallery_blockContextMenu from './behaviourParams_gallery_blockContextMenu.js';
import behaviourParams_gallery_enableIndexingShareLinks from './behaviourParams_gallery_enableIndexingShareLinks.js';
import behaviourParams_gallery_horizontal_autoSlide_behaviour from './behaviourParams_gallery_horizontal_autoSlide_behaviour.js';
import behaviourParams_gallery_horizontal_autoSlide_interval from './behaviourParams_gallery_horizontal_autoSlide_interval.js';
import behaviourParams_gallery_horizontal_autoSlide_pauseOnHover from './behaviourParams_gallery_horizontal_autoSlide_pauseOnHover.js';
import behaviourParams_gallery_horizontal_autoSlide_speed from './behaviourParams_gallery_horizontal_autoSlide_speed.js';
import behaviourParams_gallery_horizontal_blockScroll from './behaviourParams_gallery_horizontal_blockScroll.js';
import behaviourParams_gallery_horizontal_enableScrollSnap from './behaviourParams_gallery_horizontal_enableScrollSnap.js';
import behaviourParams_gallery_horizontal_loop from './behaviourParams_gallery_horizontal_loop.js';
import behaviourParams_gallery_horizontal_navigationDuration from './behaviourParams_gallery_horizontal_navigationDuration.js';
import behaviourParams_gallery_horizontal_slideAnimation from './behaviourParams_gallery_horizontal_slideAnimation.js';
import behaviourParams_gallery_horizontal_slideshowInfo_buttonsAlignment from './behaviourParams_gallery_horizontal_slideshowInfo_buttonsAlignment.js';
import behaviourParams_gallery_horizontal_slideshowInfo_enableCounter from './behaviourParams_gallery_horizontal_slideshowInfo_enableCounter.js';
import behaviourParams_gallery_horizontal_slideshowInfo_enablePlayButton from './behaviourParams_gallery_horizontal_slideshowInfo_enablePlayButton.js';
import behaviourParams_gallery_horizontal_slideTransition from './behaviourParams_gallery_horizontal_slideTransition.js';
import behaviourParams_gallery_layoutDirection from './behaviourParams_gallery_layoutDirection.js';
import behaviourParams_gallery_scrollAnimation from './behaviourParams_gallery_scrollAnimation.js';
import behaviourParams_gallery_vertical_loadMore_amount from './behaviourParams_gallery_vertical_loadMore_amount.js';
import behaviourParams_gallery_vertical_loadMore_enable from './behaviourParams_gallery_vertical_loadMore_enable.js';
import behaviourParams_gallery_vertical_loadMore_text from './behaviourParams_gallery_vertical_loadMore_text.js';
import behaviourParams_item_clickAction from './behaviourParams_item_clickAction.js';
import behaviourParams_item_content_hoverAnimation from './behaviourParams_item_content_hoverAnimation.js';
import behaviourParams_item_content_loader from './behaviourParams_item_content_loader.js';
import behaviourParams_item_content_magnificationValue from './behaviourParams_item_content_magnificationValue.js';
import behaviourParams_item_content_tiltAngleValue from './behaviourParams_item_content_tiltAngleValue.js';
import behaviourParams_item_content_placementAnimation from './behaviourParams_item_content_placementAnimation.js';
import behaviourParams_item_overlay_backgroundColor from './behaviourParams_item_overlay_backgroundColor.js';
import behaviourParams_item_overlay_hoverAnimation from './behaviourParams_item_overlay_hoverAnimation.js';
import behaviourParams_item_overlay_hoveringBehaviour from './behaviourParams_item_overlay_hoveringBehaviour.js';
import behaviourParams_item_overlay_padding from './behaviourParams_item_overlay_padding.js';
import behaviourParams_item_overlay_position from './behaviourParams_item_overlay_position.js';
import behaviourParams_item_overlay_size from './behaviourParams_item_overlay_size.js';
import behaviourParams_item_overlay_sizeUnits from './behaviourParams_item_overlay_sizeUnits.js';
import behaviourParams_item_secondaryMedia_behaviour from './behaviourParams_item_secondaryMedia_behaviour.js';
import behaviourParams_item_secondaryMedia_trigger from './behaviourParams_item_secondaryMedia_trigger.js';
import behaviourParams_item_video_enableControls from './behaviourParams_item_video_enableControls.js';
import behaviourParams_item_video_enablePlaceholder from './behaviourParams_item_video_enablePlaceholder.js';
import behaviourParams_item_video_enablePlayButton from './behaviourParams_item_video_enablePlayButton.js';
import behaviourParams_item_video_enableThumbnailsPlayButton from './behaviourParams_item_video_enableThumbnailsPlayButton.js';
import behaviourParams_item_video_loop from './behaviourParams_item_video_loop.js';
import behaviourParams_item_video_playTrigger from './behaviourParams_item_video_playTrigger.js';
import behaviourParams_item_video_speed from './behaviourParams_item_video_speed.js';
import behaviourParams_item_video_volume from './behaviourParams_item_video_volume.js';
import layoutParams_crop_alignment from './layoutParams_crop_alignment.js';
import layoutParams_crop_cropOnlyFill from './layoutParams_crop_cropOnlyFill.js';
import layoutParams_crop_enable from './layoutParams_crop_enable.js';
import layoutParams_crop_enableSmartCrop from './layoutParams_crop_enableSmartCrop.js';
import layoutParams_crop_method from './layoutParams_crop_method.js';
import layoutParams_crop_ratios from './layoutParams_crop_ratios.js';
import layoutParams_groups_allowedGroupTypes from './layoutParams_groups_allowedGroupTypes.js';
import layoutParams_groups_density from './layoutParams_groups_density.js';
import layoutParams_groups_groupByOrientation from './layoutParams_groups_groupByOrientation.js';
import layoutParams_groups_groupSize from './layoutParams_groups_groupSize.js';
import layoutParams_groups_numberOfGroupsPerRow from './layoutParams_groups_numberOfGroupsPerRow.js';
import layoutParams_groups_repeatingGroupTypes from './layoutParams_groups_repeatingGroupTypes.js';
import layoutParams_info_border_color from './layoutParams_info_border_color.js';
import layoutParams_info_border_radius from './layoutParams_info_border_radius.js';
import layoutParams_info_border_width from './layoutParams_info_border_width.js';
import layoutParams_info_height from './layoutParams_info_height.js';
import layoutParams_info_layout from './layoutParams_info_layout.js';
import layoutParams_info_placement from './layoutParams_info_placement.js';
import layoutParams_info_sizeUnits from './layoutParams_info_sizeUnits.js';
import layoutParams_info_spacing from './layoutParams_info_spacing.js';
import layoutParams_info_width from './layoutParams_info_width.js';
import layoutParams_navigationArrows_container_backgroundColor from './layoutParams_navigationArrows_container_backgroundColor.js';
import layoutParams_navigationArrows_container_borderRadius from './layoutParams_navigationArrows_container_borderRadius.js';
import layoutParams_navigationArrows_container_type from './layoutParams_navigationArrows_container_type.js';
import layoutParams_navigationArrows_enable from './layoutParams_navigationArrows_enable.js';
import layoutParams_navigationArrows_mouseCursorContainerMaxWidth from './layoutParams_navigationArrows_mouseCursorContainerMaxWidth.js';
import layoutParams_navigationArrows_padding from './layoutParams_navigationArrows_padding.js';
import layoutParams_navigationArrows_position from './layoutParams_navigationArrows_position.js';
import layoutParams_navigationArrows_size from './layoutParams_navigationArrows_size.js';
import layoutParams_navigationArrows_type from './layoutParams_navigationArrows_type.js';
import layoutParams_navigationArrows_verticalAlignment from './layoutParams_navigationArrows_verticalAlignment.js';
import layoutParams_structure_columnRatios from './layoutParams_structure_columnRatios.js';
import layoutParams_structure_enableStreching from './layoutParams_structure_enableStreching.js';
import layoutParams_structure_galleryLayout from './layoutParams_structure_galleryLayout.js';
import layoutParams_structure_galleryRatio_includeExternalInfo from './layoutParams_structure_galleryRatio_includeExternalInfo.js';
import layoutParams_structure_galleryRatio_value from './layoutParams_structure_galleryRatio_value.js';
import layoutParams_structure_gallerySpacing from './layoutParams_structure_gallerySpacing.js';
import layoutParams_structure_groupsOrder from './layoutParams_structure_groupsOrder.js';
import layoutParams_structure_itemSpacing from './layoutParams_structure_itemSpacing.js';
import layoutParams_structure_layoutOrientation from './layoutParams_structure_layoutOrientation.js';
import layoutParams_structure_numberOfColumns from './layoutParams_structure_numberOfColumns.js';
import layoutParams_structure_numberOfGridRows from './layoutParams_structure_numberOfGridRows.js'; //NEW STYPEPARAMS METHOD need to import it from the new file... an old import was already here and might break.
import layoutParams_structure_responsiveMode from './layoutParams_structure_responsiveMode.js';
import layoutParams_structure_scatter_manualScatter from './layoutParams_structure_scatter_manualScatter.js';
import layoutParams_structure_scatter_randomScatter from './layoutParams_structure_scatter_randomScatter.js';
import layoutParams_structure_scrollDirection from './layoutParams_structure_scrollDirection.js';
import layoutParams_targetItemSize_minimum from './layoutParams_targetItemSize_minimum.js';
import layoutParams_targetItemSize_unit from './layoutParams_targetItemSize_unit.js';
import layoutParams_targetItemSize_value from './layoutParams_targetItemSize_value.js';
import layoutParams_thumbnails_alignment from './layoutParams_thumbnails_alignment.js';
import layoutParams_thumbnails_enable from './layoutParams_thumbnails_enable.js';
import layoutParams_thumbnails_position from './layoutParams_thumbnails_position.js';
import layoutParams_thumbnails_size from './layoutParams_thumbnails_size.js';
import layoutParams_thumbnails_spacing from './layoutParams_thumbnails_spacing.js';
import layoutParams_thumbnails_marginToGallery from './layoutParams_thumbnails_marginToGallery.js';
import stylingParams_arrowsColor from './stylingParams_arrowsColor.js';
import stylingParams_itemBorderColor from './stylingParams_itemBorderColor.js';
import stylingParams_itemBorderRadius from './stylingParams_itemBorderRadius.js';
import stylingParams_itemBorderWidth from './stylingParams_itemBorderWidth.js';
import stylingParams_itemEnableShadow from './stylingParams_itemEnableShadow.js';
import stylingParams_itemResolutionMode from './stylingParams_itemResolutionMode.js';
import stylingParams_itemShadowBlur from './stylingParams_itemShadowBlur.js';
import stylingParams_itemShadowDirection from './stylingParams_itemShadowDirection.js';
import stylingParams_itemShadowOpacityAndColor from './stylingParams_itemShadowOpacityAndColor.js';
import stylingParams_itemShadowSize from './stylingParams_itemShadowSize.js';
import behaviourParams_item_threeDimensionalScene_transform from './behaviourParams_item_threeDimensionalScene_transform.js';
import behaviourParams_item_threeDimensionalScene_keepPosterAfterObjectLoad from './behaviourParams_item_threeDimensionalScene_keepPosterAfterObjectLoad.js';
import behaviourParams_item_threeDimensionalScene_playTrigger from './behaviourParams_item_threeDimensionalScene_playTrigger.js';
import behaviourParams_item_threeDimensionalScene_enablePlayButton from './behaviourParams_item_threeDimensionalScene_enablePlayButton.js';
import behaviourParams_item_threeDimensionalScene_enableThumbnailsPlayButton from './behaviourParams_item_threeDimensionalScene_enableThumbnailsPlayButton.js';
import behaviourParams_item_threeDimensionalScene_controls from './behaviourParams_item_threeDimensionalScene_controls.js';
// import stylingParams_itemResolutionMode from './stylingParams_itemResolutionMode.js';
//NEW STYPEPARAMS METHOD
export default Object.assign(Object.assign({ behaviourParams_gallery_blockContextMenu,
    behaviourParams_gallery_enableIndexingShareLinks,
    behaviourParams_gallery_horizontal_autoSlide_behaviour,
    behaviourParams_gallery_horizontal_autoSlide_interval,
    behaviourParams_gallery_horizontal_autoSlide_pauseOnHover,
    behaviourParams_gallery_horizontal_autoSlide_speed,
    behaviourParams_gallery_horizontal_blockScroll,
    behaviourParams_gallery_horizontal_enableScrollSnap,
    behaviourParams_gallery_horizontal_loop,
    behaviourParams_gallery_horizontal_navigationDuration,
    behaviourParams_gallery_horizontal_slideAnimation,
    behaviourParams_gallery_horizontal_slideshowInfo_buttonsAlignment,
    behaviourParams_gallery_horizontal_slideshowInfo_enableCounter,
    behaviourParams_gallery_horizontal_slideshowInfo_enablePlayButton,
    behaviourParams_gallery_horizontal_slideTransition,
    behaviourParams_gallery_layoutDirection,
    behaviourParams_gallery_scrollAnimation,
    behaviourParams_gallery_vertical_loadMore_amount,
    behaviourParams_gallery_vertical_loadMore_enable,
    behaviourParams_gallery_vertical_loadMore_text,
    behaviourParams_item_clickAction,
    behaviourParams_item_content_hoverAnimation,
    behaviourParams_item_content_loader,
    behaviourParams_item_content_magnificationValue,
    behaviourParams_item_content_tiltAngleValue,
    behaviourParams_item_content_placementAnimation,
    behaviourParams_item_overlay_backgroundColor,
    behaviourParams_item_overlay_hoverAnimation,
    behaviourParams_item_overlay_hoveringBehaviour,
    behaviourParams_item_overlay_padding,
    behaviourParams_item_overlay_position,
    behaviourParams_item_overlay_size,
    behaviourParams_item_overlay_sizeUnits,
    behaviourParams_item_secondaryMedia_behaviour,
    behaviourParams_item_secondaryMedia_trigger,
    behaviourParams_item_video_enableControls,
    behaviourParams_item_video_enablePlaceholder,
    behaviourParams_item_video_enablePlayButton,
    behaviourParams_item_video_enableThumbnailsPlayButton,
    behaviourParams_item_video_loop,
    behaviourParams_item_video_playTrigger,
    behaviourParams_item_video_speed,
    behaviourParams_item_video_volume,
    layoutParams_crop_alignment,
    layoutParams_crop_cropOnlyFill,
    layoutParams_crop_enable,
    layoutParams_crop_enableSmartCrop,
    layoutParams_crop_method,
    layoutParams_crop_ratios,
    layoutParams_groups_allowedGroupTypes,
    layoutParams_groups_density,
    layoutParams_groups_groupByOrientation,
    layoutParams_groups_groupSize,
    layoutParams_groups_numberOfGroupsPerRow,
    layoutParams_groups_repeatingGroupTypes,
    layoutParams_info_border_color,
    layoutParams_info_border_radius,
    layoutParams_info_border_width,
    layoutParams_info_height,
    layoutParams_info_layout,
    layoutParams_info_placement,
    layoutParams_info_sizeUnits,
    layoutParams_info_spacing,
    layoutParams_info_width,
    layoutParams_navigationArrows_container_backgroundColor,
    layoutParams_navigationArrows_container_borderRadius,
    layoutParams_navigationArrows_container_type,
    layoutParams_navigationArrows_enable,
    layoutParams_navigationArrows_mouseCursorContainerMaxWidth,
    layoutParams_navigationArrows_padding,
    layoutParams_navigationArrows_position,
    layoutParams_navigationArrows_size,
    layoutParams_navigationArrows_type,
    layoutParams_navigationArrows_verticalAlignment,
    layoutParams_structure_columnRatios,
    layoutParams_structure_enableStreching,
    layoutParams_structure_galleryLayout,
    layoutParams_structure_galleryRatio_includeExternalInfo,
    layoutParams_structure_galleryRatio_value,
    layoutParams_structure_gallerySpacing,
    layoutParams_structure_groupsOrder,
    layoutParams_structure_itemSpacing,
    layoutParams_structure_layoutOrientation,
    layoutParams_structure_numberOfColumns,
    layoutParams_structure_numberOfGridRows,
    layoutParams_structure_responsiveMode,
    layoutParams_structure_scatter_manualScatter,
    layoutParams_structure_scatter_randomScatter,
    layoutParams_structure_scrollDirection,
    layoutParams_targetItemSize_minimum,
    layoutParams_targetItemSize_unit,
    layoutParams_targetItemSize_value,
    layoutParams_thumbnails_alignment,
    layoutParams_thumbnails_enable,
    layoutParams_thumbnails_position,
    layoutParams_thumbnails_size,
    layoutParams_thumbnails_spacing,
    layoutParams_thumbnails_marginToGallery,
    stylingParams_arrowsColor,
    stylingParams_itemBorderColor,
    stylingParams_itemBorderRadius,
    stylingParams_itemBorderWidth,
    stylingParams_itemEnableShadow,
    stylingParams_itemResolutionMode,
    stylingParams_itemShadowBlur,
    stylingParams_itemShadowDirection,
    stylingParams_itemShadowOpacityAndColor,
    stylingParams_itemShadowSize,
    behaviourParams_item_threeDimensionalScene_keepPosterAfterObjectLoad,
    behaviourParams_item_threeDimensionalScene_playTrigger,
    behaviourParams_item_threeDimensionalScene_enablePlayButton,
    behaviourParams_item_threeDimensionalScene_enableThumbnailsPlayButton }, behaviourParams_item_threeDimensionalScene_transform), behaviourParams_item_threeDimensionalScene_controls);
// v5 TODO = add the options:
/*
itemOpacity
imageLoadingColor
oneColorAnimationColor
*/
//# sourceMappingURL=index.js.map